var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jSingleFileUploader" },
    [
      _c(
        "div",
        [
          _c(
            "b-card",
            {
              staticClass: "cursor-pointer",
              class: _vm.determineThumbnail,
              attrs: { "img-src": _vm.thumbnail || _vm.fileUrl, overlay: "" },
              on: { click: _vm.clickedPreviewCard }
            },
            [
              (_vm.thumbnail || _vm.fileUrl) && !_vm.disabled
                ? _c("i", {
                    staticClass: "fa fa-close fa__delete-icon",
                    on: { click: _vm.deleteFile }
                  })
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-form-file", {
        ref: "fileinput",
        attrs: { plain: "" },
        model: {
          value: _vm.file,
          callback: function($$v) {
            _vm.file = $$v
          },
          expression: "file"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100 text-center cursor-pointer",
          on: { click: _vm.clickBrowseButton }
        },
        [
          _c("img", { attrs: { src: require("@/assets/icon/camera.png") } }),
          _vm._v(" "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "imageModal",
          attrs: {
            "ok-only": true,
            "hide-header": true,
            "hide-footer": true,
            centered: true
          }
        },
        [_c("img", { attrs: { src: _vm.thumbnail || _vm.fileUrl } })]
      ),
      _vm._v(" "),
      _c("jProblemScreen", {
        ref: "problemScreen",
        attrs: { message: _vm.error_message }
      }),
      _vm._v(" "),
      _c("jSuccessScreen", {
        ref: "successScreen",
        attrs: { message: "File has been successfully uploaded" }
      }),
      _vm._v(" "),
      _c("jLoadingScreen", { ref: "loadingScreen" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b0d64a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0d64a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload-foto/jPhotoUploader.vue
// module id = null
// module chunks = 